<script setup>
import { computed } from 'vue'
const props = defineProps({
  primary: Boolean,
  secondary: Boolean,
  disabled: {
    type: Boolean,
    default: false
  },
  small: Boolean,
  large: Boolean,
  danger: Boolean,
})

const buttonClasses = computed(() => {
  const baseClasses = 'inline-flex items-center border w-fit font-medium rounded-lg border hover:border-accent transition-colors duration-200 focus:outline-none focus:ring-2 disabled:opacity-50 disabled:pointer-events-none';

  let sizeClasses = ''
  switch(true){
    case props.small:
      sizeClasses = 'px-4 py-2 text-sm'
      break
    case props.large:
      sizeClasses = 'px-8 py-3 text-lg'
      break
    default:
      sizeClasses = 'px-6 py-2'
      break
  }

  let colorClasses = ''
  switch(true){
    case props.primary:
      colorClasses = 'bg-accent text-light focus:ring-light border-secondary '
      break
    case props.secondary:
      colorClasses = 'bg-surface-primary text-accent focus:ring-accent border-secondary '
      break
    case props.danger:
      colorClasses = 'bg-red-400 dark:bg-red-900 text-light focus:ring-light border-red-500 dark:border-red-950 hover:bg-red-500 dark:hover:bg-red-600 hover:border-red-600 dark:hover:border-red-800 text-white'
      break
    default:
      colorClasses = 'bg-accent text-light border-secondary '
      break
  }

  return [baseClasses, colorClasses, sizeClasses].join(' ');
});
</script>


<template>
  <button :class="buttonClasses" :disabled="disabled">
    <slot />
  </button>
</template>

<style scoped></style>
